import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/ro';
import { getMovieSchedule } from '../../actions/movies.actions';
import { storeSelectedDate } from "../../actions/filters.actions";
import { clearHallConfiguration } from '../../actions/movietheaters.actions';
import {withRouter} from 'react-router';

class WeekDaysCards extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDay: moment().format('YYYY-MM-DD')
        };
    }

    componentWillMount(){
        let payload = {}
        
        if (this.props.selectedDate){
            payload = {
                film_id: this.props.match.params.id,
                date: this.props.selectedDate,
                locality: localStorage.getItem("cinema_location")
            }
           this.setState({selectedDay: this.props.selectedDate});
        } else {
            this.props.storeSelectedDate(moment().format('YYYY-MM-DD'));
            payload = {
                film_id: this.props.match.params.id,
                date: moment().format('YYYY-MM-DD'),
                locality: localStorage.getItem("cinema_location")
            }
        }
        this.props.getMovieSchedule(payload);
    }

    componentWillReceiveProps(nextProps){
        if(this.props.selectedLocality !== nextProps.selectedLocality){
            const payload = {
                film_id: this.props.match.params.id,
                date: this.state.selectedDay,
                locality: localStorage.getItem("cinema_location")
            }
            this.props.getMovieSchedule(payload);
            this.props.storeSelectedDate(this.state.selectedDay);
        }
        if (nextProps.match.params.id !== this.props.match.params.id) {
            const payload = {
                film_id: nextProps.match.params.id,
                date: this.state.selectedDay,
                locality: localStorage.getItem("cinema_location")
            }
            this.props.getMovieSchedule(payload);
            this.props.storeSelectedDate(this.state.selectedDay);
        }
    }

    getDates() {
        let dates = [];
        let i; 
        for (i = 0; i <= 6; i++) {    
            let now = moment().locale('ro');  
            dates.push(now.add(i, 'days'))
        }

        let formatedDates = [];
        for (i = 0; i < 7; i++) {
            formatedDates.push({
                id: i + 1,
                day: dates[i].format('DD'),
                dayString: dates[i].format('dd'),
                month: dates[i].format('MMM'),
                fullDate: dates[i].format("YYYY-MM-DD")
            });
        }
        return formatedDates;
    }
    changeSelectedDay(date) {
        this.setState({
            selectedDay: date.date.fullDate
        });
        const payload = {
            film_id: this.props.match.params.id,
            date: date.date.fullDate,
            locality: localStorage.getItem("cinema_location")
        }
        this.props.clearHallConfiguration();
        this.props.getMovieSchedule(payload);
        this.props.storeSelectedDate(date.date.fullDate);
    }

    showDates(date) {
        let isSelected = false;
        if (date.day === moment().format('DD')) {
            date.dayString = 'Azi';
        }
        if (date.fullDate === this.state.selectedDay) {
            isSelected = true;
        }

        if(isSelected){
            return <div key={date.id} className="col item-day active">
                <div className="headline-day">
                    {date.dayString}
                </div>
                <div className="content-day">
                    <span>{date.day}</span>
                    <span>{date.month}</span>
                </div>
            </div>
        } else {
            return <div key={date.id} className="col item-day" onClick={this.changeSelectedDay.bind(this, { date })}>
                <div className="headline-day">
                    {date.dayString}
                    </div>
                <div className="content-day">
                    <span>{date.day}</span>
                    <span>{date.month}</span>
                </div>
            </div>
        }
    }

    render() {
        let dates = this.getDates();
        return (
            <Fragment>
                {dates.map(this.showDates, this)}
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    selectedLocality: state.filters.selectedCinemaLocation,
    selectedDate: state.filters.reservetionSelectedDate
});
export default withRouter(connect(mapStateToProps, {getMovieSchedule, storeSelectedDate, clearHallConfiguration})(WeekDaysCards));


// WEBPACK FOOTER //
// ./src/SHARED/components/weekdayscards/weekdayscards.component.js